import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Wrench, Cog, Droplet, Truck, Check } from "lucide-react";

const services = [
  { icon: Wrench, t: "Cylinder Rebuild", bullets: ["Full teardown & inspection", "Honing & re-machining as needed", "New OEM-spec seal kits", "Pressure & leak test before pickup"] },
  { icon: Cog, t: "Chrome Rod Work", bullets: ["Bent rod straightening", "Rod re-chroming", "Replacement rods cut to spec", "Pitting & score repair"] },
  { icon: Droplet, t: "Seal Replacement", bullets: ["Rod, piston, wiper, and buffer seals", "Kit sourcing for legacy equipment", "Same-day service on common bores", "Warrantied leak-free"] },
  { icon: Truck, t: "On-Site Repair", bullets: ["$75/hr, 2 hour minimum", "50 mile radius from Greensburg", "$150 deposit to schedule", "Emergency service available"] },
];

export default function Services() {
  return (
    <Layout>
      <section className="mx-auto max-w-7xl px-4 sm:px-8 py-16">
        <div className="eyebrow mb-2">Services</div>
        <h1 className="hero-title text-4xl sm:text-5xl text-white">If it holds pressure, we can fix it.</h1>
        <p className="mt-4 text-slate-400 max-w-2xl">Every job on the bench gets specs measured, symptoms confirmed, and photos on file — so you never wonder what's happening to your cylinder.</p>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {services.map(s => (
            <div key={s.t} className="shop-card p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-red-600/15 border border-red-600/40 flex items-center justify-center rounded-sm">
                  <s.icon className="w-6 h-6 text-red-500" />
                </div>
                <div className="font-display font-black text-2xl uppercase text-white">{s.t}</div>
              </div>
              <ul className="mt-5 space-y-2">
                {s.bullets.map(b => (
                  <li key={b} className="flex items-start gap-2 text-slate-300 text-sm">
                    <Check className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" /> {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row gap-3">
          <Link to="/intake" data-testid="services-intake" className="btn-red px-8 py-5 rounded-sm">Bring In A Cylinder</Link>
          <Link to="/onsite" data-testid="services-onsite" className="btn-outline px-8 py-5 rounded-sm">Book On-Site Service</Link>
        </div>
      </section>
    </Layout>
  );
}
